<template>
  <div>
    <div class="carTitle">
      <!-- 购物车 __ 管理 -->
      <span>{{$t('detail.cart')}}</span>
      <span>{{$t('detail.mange')}}</span>
    </div>
    <div v-if="!shopCardGoods" class="empty_cart">
      <van-icon name="shopping-cart-o" class="icon" />
      <!-- 空空如也 -->
      <span class="isKong">{{$t('tips.empty')}}</span>
    </div>
    <!-- 复选框 -->
    <van-checkbox-group class="card-goods" v-model="checkedGoods" @change='getPackagePrice'>
      <van-checkbox
        class="card-goods__item"
        v-for="(item,i) in shopCardGoods"
        :key="i"
        :name='i'
        @click="toggle(i)"
      >
      <!-- 套餐名 -->
        <span style="margin-left: 10px;;font-size:15px" >{{item.packageName}}</span>
        <div v-for="(items,index) in item.item " :key='index' >
          <van-card
          :v-for="(items,index) in items"
          :key="index"
          :title="items.prodName"
          :thumb="items.pic"
          :desc="items.selectedSkuName"
          :num="items.num"
          :price="formatPrice(items.selectedSkuPrice)"
          :currency='$t("Pay.money")'
        />
        </div>
        <!-- 套餐价格  运费 -->
        <span >{{$t('Pay.setMeal')}}：{{$t('Pay.money')}} {{item.PackagePrice}}</span>    <span>{{$t('order3.freight')}}:{{$t('Pay.money')}}{{item.combofareText}}</span>
        
      </van-checkbox>
    </van-checkbox-group>

    <van-submit-bar
      :price="totalPrice"
      :disabled="!checkedGoods.length"
      :button-text="submitBarText"
      @submit="onSubmit"
      :currency='$t("Pay.money")'
    >
      <van-goods-action-icon icon="wap-home" @click="home">{{$t('index.index')}}</van-goods-action-icon>
    </van-submit-bar>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapMutations, mapState } from 'vuex';
import { findIndex, remove, cloneDeep } from 'lodash';
export default {
  data() {
    return {
      i:'',
      index:'',
      item:[],
      items:[],
      checkedGoods: [],
      // currency:'NT$sss'
      totalPrice:0,
      num:0,
      shopCardGoods:[],
      orderItemNums:0,
      List:[],
      istrueList:[],
      istrue:false,
    };
  },
  created(){
    //开始的时候初始化 这个数组
    sessionStorage.removeItem('prodLists')
    //取得缓存数据
    this.shopCardGoods = JSON.parse(sessionStorage.getItem('orderItems'))

    if(this.shopCardGoods ){
      this.shopCardGoods.forEach((item,index)=>{
        // 初始化这个数组 然后加入两个值,用来判断加入的是第几个商品,他的状态是否为true,和套餐价格
        this.istrueList.push({'istrue':this.istrue,total:item.PackagePrice + item.combofareText})
      })
    }
  
  },
  computed: {
    submitBarText() {
      const count = this.checkedGoods.length;
      return this.$t('cart.account') + (count ? `(${count})` : '');
    },

  },
  mounted() {
    
  },
  methods: {
    ...mapMutations('goods', {
      refreshOrderGoods: 'refreshOrderGoods',
      removeShopCardGoods: 'removeShopCardGoods',
    }),
    getPackagePrice(e){
      let List = []
      e.forEach((item,index)=>{
        List.push(this.istrueList[item].total)
      })
        if(List.length>0){
          //计算价格
         this.totalPrice = List.reduce((total,item)=>total + item) *100 
        }
        if(e.length == 0){
          this.totalPrice = 0
        }
    },
    toggle(index){
      //点击 改变他们的状态,如果为true则为选中
      this.istrueList[index].istrue = !this.istrueList[index].istrue
    },
    formatPrice(price) {
      return price;
    },
    home() {
      this.$router.replace('/');
    },
    onSubmit() {
      this.istrueList.forEach((item,index)=>{
        if(item.istrue){
// 把购物车的数据再缓存传入 下单页
          let List = []
          if(index == 0){
            List.push(this.shopCardGoods[index])
            sessionStorage.setItem('prodLists',JSON.stringify(List))
            }else {
              if(sessionStorage.getItem('prodLists') !=null){
                JSON.parse(sessionStorage.getItem('prodLists')).forEach((item,index)=>{
                  List.push(item)
                })
              }
              List.push(this.shopCardGoods[index])
              sessionStorage.setItem('prodLists',JSON.stringify(List))
            }
            // this.$router.push('/orderStep4')
            
            // this.$router.push({ path: "/GoodsCategory", query: { index: id } });
        }
      })
      this.$router.push({ path: "orderStep4"  + '/car'  });
    },
    catchEvent() {
      event.stopPropagation(); //原生阻止冒泡事件
    },
  },
};
</script>

<style lang="scss">
.empty_cart {
  padding-top: 3rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  .icon {
    font-size: 1rem;
    color: red;
  }
}
.card-goods {
  padding: 10px 0;
  background-color: #fff;
  &__item {
    position: relative;
    background-color: #fafafa;
    .sku {
      margin-top: 0.2rem;
    }
    .icon_delete {
      font-size: 0.6rem;
    }
    .van-checkbox__label {
      width: 100%;
      height: auto; // temp
      padding: 0 10px 0 15px;
      box-sizing: border-box;
    }
    .van-checkbox__icon {
      top: 50%;
      left: 10px;
      z-index: 1;
      position: absolute;
      margin-top: -10px;
    }
    .van-card__price {
      color: #f44;
    }
  }
}
.van-submit-bar__price{
      font-size: 15px;
}
.carTitle{
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.card-goods__item{
  padding-bottom: 20px;
}
.isKong{
  font-size:0.5rem;
  margin-top:0.32rem;
}
@media screen and (min-width: 970px) {
  .isKong{
    font-size:0.2rem;
    margin-top:0.12rem;
  }
  .empty_cart {
  padding-top: 1rem;
  .icon {
    font-size: 0.5rem;
  }
}
}

</style>


// WEBPACK FOOTER //
// src/pages/Cart.vue